import { render, staticRenderFns } from "./orderReceived.vue?vue&type=template&id=22fa81c4&scoped=true&"
import script from "./orderReceived.vue?vue&type=script&lang=js&"
export * from "./orderReceived.vue?vue&type=script&lang=js&"
import style0 from "./orderReceived.vue?vue&type=style&index=0&id=22fa81c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fa81c4",
  null
  
)

export default component.exports